/*
 * DashboardSecuritySettings Messages
 *
 * This contains all the text for the DashboardSecuritySettings scene.
 */

import { defineMessages } from "utils/defineMessages";

export const scope = "app.scenes.DashboardSecuritySettings";

export default defineMessages(scope, {
  header: "This is the DashboardSecuritySettings scene!",
  securitySettings: "SECURITY SETTINGS",
  mfaSettings: "MFA Settings",
  password: "Password", // NOSONAR
  edit: "Edit",
  phone: "Phone Authentication",
  okta: "Okta Verify",
  app: "Authenticator App",
  email: "Email Authentication",
  envapp: "Authenticator App",
  passkey: "Passkey Authentication",
  username: "Username",
  backToDashboard: "Back to Dashboard",
  passkeys: "Passkeys",
  setUpPasskey: "Set up a passkey",
  addPasskey: "Add a passkey",
  noPasskeys:
    "You haven’t added any passkeys. Add a passkey for quick password free sign on.",
  cancelDelete: "No, Cancel",
  confirmDelete: "Yes, Delete",
  deletePasskey: "Delete Passkey",
  deletePasskeyConfirmation: "Are you sure you want to delete this passkey?",
});
